import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

const prefixUrl = "/access/request";

export default {
    async list(param: types.accessRequest.ReqAccessRequestForList): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/list", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detail(idx: number): Promise<types.accessRequest.ResAccessRequest> {
        const res = {} as types.accessRequest.ResAccessRequest;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + `/detail/${idx}`, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async detailForTarget(type: 1 | 2, targetIdx: number): Promise<types.accessRequest.ResAccessRequestForTarget> {
        const res = {} as types.accessRequest.ResAccessRequestForTarget;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + `/detail/${type}/${targetIdx}`, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async add(param: types.accessRequest.ReqAccessRequest): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/add", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modify(idx: number, param: types.accessRequest.ReqAccessRequestForProcess): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/modify/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async modifyForMulti(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/modify/multi", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async remove(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + "/remove/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },

    async status(): Promise<types.accessRequest.ResAccessRequestForStatus> {
        const res = {} as types.accessRequest.ResAccessRequestForStatus;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(prefixUrl + `/status`, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            return error.response.data;
        }
        return res;
    },
};
